export default {
    updateDataGet(state, val) {
        state.dataGet = val;
    },
    updatePages(state, val) {
        state.dataGet.pages = val;
    },
    updateDataPost(state, val) {
        state.dataPost = val;
    },
    updateSettings(state, val) {
        state.settings = val;
    },
    updateDataPostByIndex(state, {val, index}){
        state.dataPost[index] = val;
    },
    updateReviewFieldByIndex(state, {val, index}){
        state.reviewField[index] = val;
    },
    updateAlerts(state, val) {
        state.alerts = val;
    },
    updateValue(state, val) {
        state.value = val;
    },
    updateSubmitLoading(state, val) {
        state.submitLoading = val;
    },
    submitFormStatus(state, { status, type, message }) {
        state.submitLoading = false;
        state.isForm = !status;
        if (message != null) state.isFormMessage = true;
        if (status) state.dataGet = {};
        state.formMessage = message;
        state.formMessageType = type;
    },
    updateIsForm(state, val){
        state.isForm = val;
    },
    updateUrl(state, val) {
        state.urlUpload = state.baseUrl + '/' + val + '/upload'
        state.url = state.baseUrl + '/' + val;
    },
    updateStep(state, val) {
        state.step = val
    },
    updateStepCount(state, val){
        state.stepCount = val;
    },
};